/* eslint-disable react/prop-types */
/* eslint-disable react/display-name */
import React from "react";
import moment from "moment";
import TableCell from "../../../components/TableCell";

const roundToQuarters = value =>
  typeof value === "number"
    ? (Math.ceil(value / 0.25) * 0.25).toFixed(2)
    : null;

export const ORDER_COLUMNS = [
  {
    Header: "Customer #",
    accessor: "Customer.CustomerNo",
    id: "CustomerNumber"
  },
  {
    Header: "Customer Name",
    accessor: "Customer.Name",
    id: "CustomerName"
  },
  {
    Header: "Order #",
    accessor: "OrderNumber",
    id: "OrderNumber"
  },
  {
    Header: "Order Date",
    accessor: "OrderDate",
    id: "OrderDate",
    Cell: ({ cell }) =>
      cell.value ? moment(cell.value).format("MM/DD/YYYY") : null
  },
  {
    Header: "Pickup Date",
    accessor: "PickupDate",
    id: "PickupDate",
    Cell: ({ cell }) =>
      cell.value ? moment(cell.value).format("MM/DD/YYYY") : null
  },
  {
    Header: "Driver",
    accessor: "Driver",
    id: "Driver"
  },
  {
    Header: "Status",
    accessor: "Status.CodeDescription",
    id: "Status"
  },
  {
    Header: "Pickup ID",
    accessor: "Route.PickupLocation.LocationID",
    id: "PickupLocationID"
  },
  {
    Header: "Pickup Location",
    accessor: "Route.PickupLocation.LocationName",
    id: "PickupLocation"
  },
  {
    Header: "Delivery ID",
    accessor: "Route.DeliveryLocation.LocationID",
    id: "DeliveryLocationID"
  },
  {
    Header: "Delivery Location",
    accessor: "Route.DeliveryLocation.LocationName",
    id: "DeliveryLocation"
  }
];
export const COLUMNS = [
  {
    Header: "Order #",
    accessor: "OrderNumber",
    id: "OrderNumber"
  },
  {
    Header: "Customer",
    accessor: "Customer.Name",
    id: "Customer"
  },
  {
    Header: "Route Id",
    accessor: "Route.RouteId",
    id: "RouteId"
  },
  {
    Header: "Route Description",
    accessor: "Route.RouteDescription",
    id: "RouteDescription"
  },
  {
    Header: "Load Type",
    accessor: "Route.LoadType.CodeName",
    id: "LoadType"
  },
  {
    Header: "Start Location",
    accessor: "Route.StartLocation.LocationName",
    id: "StartLocation"
  },
  {
    Header: "Pickup Location",
    accessor: "Route.PickupLocation.LocationName",
    id: "PickupLocation"
  },
  {
    Header: "Delivery Location",
    accessor: "Route.DeliveryLocation.LocationName",
    id: "DeliveryLocation"
  },
  {
    Header: "Ending Location",
    accessor: "Route.EndLocation.LocationName",
    id: "EndingLocation"
  },
  {
    Header: "Estimated Load (hrs)",
    accessor: "EstimatedLoad",
    id: "EstimatedLoad",
    Cell: ({ cell }) => (cell.value ? roundToQuarters(cell.value) : null)
  },
  {
    Header: "Estimated Travel (hrs)",
    accessor: "EstimatedTravel",
    id: "EstimatedTravel",
    Cell: ({ cell }) => (cell.value ? roundToQuarters(cell.value) : null)
  },
  {
    Header: "Estimated Uload",
    accessor: "EstimatedUload",
    id: "EstimatedUload",
    Cell: ({ cell }) => (cell.value ? roundToQuarters(cell.value) : null)
  },
  {
    Header: "Order Date",
    accessor: "OrderDate",
    id: "OrderDateTime",
    Cell: ({ cell }) =>
      cell.value ? moment(cell.value).format("MM/DD/YYYY") : null
  },
  {
    Header: "Order Time",
    accessor: "OrderTime",
    id: "OrderTime",
    Cell: ({ cell }) => (cell.value ? moment(cell.value).format("HH:mm") : null)
  },
  {
    Header: "Requested Delivery Date",
    accessor: "RequestedDeliveryDate",
    id: "RequestedDeliveryDate",
    Cell: ({ cell }) =>
      cell.value ? moment(cell.value).format("MM/DD/YYYY") : null
  },
  {
    Header: "Requested Delivery Time",
    accessor: "RequestedDeliveryTime",
    id: "RequestedDeliveryTime",
    Cell: ({ cell }) => (cell.value ? moment(cell.value).format("HH:mm") : null)
  },
  {
    Header: "Scheduled Delivery Date",
    accessor: "ScheduledDeliveryDate",
    id: "ScheduledDeliveryDate",
    Cell: ({ cell }) =>
      cell.value ? moment(cell.value).format("MM/DD/YYYY") : null
  },
  {
    Header: "Scheduled Delivery Time",
    accessor: "ScheduledDeliveryTime",
    id: "ScheduledDeliveryTime",
    Cell: ({ cell }) => (cell.value ? moment(cell.value).format("HH:mm") : null)
  },
  {
    Header: "Pickup Date",
    accessor: "PickupDate",
    id: "PickupDate",
    Cell: ({ cell }) =>
      cell.value ? moment(cell.value).format("MM/DD/YYYY") : null
  },
  {
    Header: "Pickup Time",
    accessor: "PickupTime",
    id: "PickupTime",
    Cell: ({ cell }) => (cell.value ? moment(cell.value).format("HH:mm") : null)
  },
  {
    Header: "Bill To",
    accessor: "BillTo.BillingContactName",
    id: "BillTo",
    Cell: ({ cell }) => cell.value
  }
];

export const ORDER_DETAIL_COLUMNS = [
  {
    Header: "Product #",
    accessor: "Product.ProductCode",
    id: "ProductNumber"
  },
  {
    Header: "Description",
    accessor: "Description",
    id: "Description"
  },
  {
    Header: "Quantity",
    accessor: "Quantity",
    id: "Quantity"
  },
  {
    Header: "Hazmat Code",
    accessor: "Hazmat",
    id: "HazmatCode"
  },
  {
    Header: "UOM",
    accessor: "UnitOfMeasurement.CodeDescription",
    id: "UOM"
  }
];

export const ORDER_VIEW_COLUMNS = [
  {
    Header: "Customer #",
    accessor: "CustomerNo",
    id: "CustomerNo"
  },
  {
    Header: "Customer Name",
    accessor: "CustomerName",
    id: "CustomerName"
  },
  {
    Header: "Order #",
    accessor: "OrderNumber",
    id: "OrderNumber"
  },

  {
    Header: "Pickup Date",
    accessor: "PickupDate",
    id: "PickupDate",
    Cell: ({ cell }) =>
      cell.value ? moment(cell.value).format("MM/DD/YYYY") : null
  },
  {
    Header: "Status",
    accessor: "StatusIdDescription",
    id: "StatusIdDescription"
  },
  {
    Header: "",
    accessor: "StatusIdListOrder",
    id: "StatusIdListOrder"
  },
  {
    Header: "Pickup ID",
    accessor: "Pickup_LocationId",
    id: "PickupLocationID"
  },
  {
    Header: "Pickup Location",
    accessor: "PickUp_LocationName",
    id: "PickupLocation"
  },
  {
    Header: "City",
    accessor: "PickUp_City",
    id: "PickUp_City"
  },
  {
    Header: "State",
    accessor: "PickUp_State",
    id: "PickUp_State"
  },
  {
    Header: "Delivery ID",
    accessor: "Del_LocationId",
    id: "DeliveryLocationID"
  },
  {
    Header: "Delivery Location",
    accessor: "Del_LocationName",
    id: "Del_LocationName"
  },
  {
    Header: "City",
    accessor: "Del_City",
    id: "Del_City"
  },
  {
    Header: "State",
    accessor: "Del_State",
    id: "Del_State"
  },
  {
    Header: "Driver Id",
    accessor: "PickupDriver",
    id: "PickupDriver"
  },
  {
    Header: "Driver Name",
    accessor: "PickupDriverLastName",
    id: "PickupDriverLastName"
  },
  {
    Header: "Tractor",
    accessor: "PickupTractor",
    id: "PickupTractor"
  },
  {
    Header: "Trailer",
    accessor: "PickupTrailer",
    id: "PickupTrailer"
  },
  {
    Header: "Order Date",
    accessor: "OrderDate",
    id: "OrderDate",
    Cell: ({ cell }) =>
      cell.value ? moment(cell.value).format("MM/DD/YYYY") : null
  },
  {
    Header: "Bill To",
    id: "BillTo",
    accessor: "BillToName"
  },
  {
    Header: "Payment Term",
    id: "TermCode",
    accessor: "TermCode"
  },
  {
    Header: "Verified By",
    accessor: "VerifiedByUserId",
    id: "VerifiedByUserId"
  },
  {
    Header: "Created Date",
    accessor: "CreatedDateTime",
    id: "CreatedDateTime",
    Cell: ({ cell }) =>
      cell.value ? moment(cell.value).format("MM/DD/YYYY HH:mm") : null
  },
  {
    Header: "Created By",
    accessor: "CreatedBy",
    id: "CreatedBy"
  },
  {
    Header: "Modified Date",
    accessor: "ModifiedDateTime",
    id: "ModifiedDateTime",
    Cell: ({ cell }) =>
      cell.value ? moment(cell.value).format("MM/DD/YYYY") : null
  },
  {
    Header: "Modified By",
    accessor: "ModifiedBy",
    id: "ModifiedBy"
  }
];

const colors = [
  {
    name: "Not Exported",
    color: "#363636"
  },
  {
    name: "To Export",
    color: "#4b71b7"
  },
  {
    name: "Exported",
    color: "#55a255"
  },
  {
    name: "To Import",
    color: "#44cc00"
  },
  {
    name: "Imported",
    color: "#e63462"
  }
];

export const ORDER_VIEW_COLUMNS_ELD = [
  {
    Header: "Pickup Date",
    accessor: "PickupDate",
    id: "PickupDate",
    Cell: ({ cell }) =>
      cell.value ? moment(cell.value).format("MM/DD/YYYY") : null
  },
  {
    Header: "Trip #",
    id: "Trip",
    accessor: "Trip"
  },
  {
    Header: "Leg #",
    id: "Leg",
    accessor: "Leg"
  },
  {
    Header: "Order #",
    accessor: "OrderNumber",
    id: "OrderNumber",
    Cell: ({ cell }) => (
      <TableCell.Link
        to={`/dispatch/orders/${cell.row.original.RecId}/summary`}
        value={cell.row.original.OrderNumber}
      />
    )
  },
  {
    Header: "Driver Name",
    accessor: "PickupDriverLastName",
    id: "PickupDriverLastName",
    Cell: obj => {
      const item = obj.data[obj.row.id];
      return `${item.PickupDriverFirstName}, ${item.PickupDriverLastName}`;
    }
  },
  {
    Header: "Tractor",
    accessor: "PickupTractor",
    id: "PickupTractor"
  },
  {
    Header: "Trailer",
    accessor: "PickupTrailer",
    id: "PickupTrailer"
  },
  {
    Header: "Pickup ID",
    accessor: "Pickup_LocationId",
    id: "PickupLocationID"
  },
  {
    Header: "Pickup Location",
    accessor: "PickUp_LocationName",
    id: "PickupLocation"
  },
  {
    Header: "City",
    accessor: "PickUp_City",
    id: "PickUp_City"
  },
  {
    Header: "State",
    accessor: "PickUp_State",
    id: "PickUp_State"
  },
  {
    Header: "Delivery ID",
    accessor: "Del_LocationId",
    id: "DeliveryLocationID"
  },
  {
    Header: "Delivery Location",
    accessor: "Del_LocationName",
    id: "DeliveryLocation"
  },
  {
    Header: "City",
    accessor: "Del_City",
    id: "Del_City"
  },
  {
    Header: "State",
    accessor: "Del_State",
    id: "Del_State"
  },
  {
    Header: "Order Date",
    accessor: "OrderDate",
    id: "OrderDate",
    Cell: ({ cell }) =>
      cell.value ? moment(cell.value).format("MM/DD/YYYY") : null
  },
  {
    Header: "Verified By",
    accessor: "VerifiedByUserId",
    id: "VerifiedByUserId"
  },
  {
    Header: "ELD Status",
    accessor: "ELDStatus.CodeDescription",
    id: "ELDStatus",
    Cell: ({ cell }) => {
      if (cell?.value) {
        const { color } = colors.find(c => c.name === cell.value);
        return <span style={{ color }}>{cell.value}</span>;
      }
      return "";
    }
  },
  {
    Header: "Customer #",
    accessor: "CustomerNo",
    id: "CustomerNo"
  },
  {
    Header: "Customer Name",
    accessor: "CustomerName",
    id: "CustomerName"
  },
  {
    Header: "Created Date",
    accessor: "CreatedDateTime",
    id: "CreatedDateTime",
    Cell: ({ cell }) =>
      cell.value ? moment(cell.value).format("MM/DD/YYYY HH:mm") : null
  },
  {
    Header: "Created By",
    accessor: "CreatedBy",
    id: "CreatedBy"
  },
  {
    Header: "Modified Date",
    accessor: "ModifiedDateTime",
    id: "ModifiedDateTime",
    Cell: ({ cell }) =>
      cell.value ? moment(cell.value).format("MM/DD/YYYY") : null
  },
  {
    Header: "Modified By",
    accessor: "ModifiedBy",
    id: "ModifiedBy"
  }
];
